// extracted by mini-css-extract-plugin
export default {"metric":"Metric_metric__qECj0","metricValue":"Metric_metricValue__3aonQ"};